import { createFileRoute, notFound } from "@tanstack/react-router";
import LocationPage from "@/pages/LocationPage";
import { legacyRedirect } from "@/lib/legacy-redirect";
import { isLocationSlug, locationHead } from "@/lib/route-seo";
import NotFound from "@/pages/NotFound";

// Legacy short-slug location redirects → canonical {city}-{state} slug
// plus retired Ohio service-area pages → /service-area (ported from src/App.tsx)
const LEGACY_SLUGS: Record<string, string> = {
  "louisville": "/service-area/louisville-ky",
  "elizabethtown": "/service-area/elizabethtown-ky",
  "lexington": "/service-area/lexington-ky",
  "bardstown": "/service-area/bardstown-ky",
  "simpsonville": "/service-area/simpsonville-ky",
  "shepherdsville": "/service-area/shepherdsville-ky",
  "hillview": "/service-area/hillview-ky",
  "mt-washington": "/service-area/mt-washington-ky",
  "jeffersontown": "/service-area/jeffersontown-ky",
  "st-matthews": "/service-area/st-matthews-ky",
  "la-grange": "/service-area/la-grange-ky",
  "cox's-creek": "/service-area/coxs-creek-ky",
  "coxs-creek": "/service-area/coxs-creek-ky",
  "new-albany": "/service-area/new-albany-in",
  "jeffersonville": "/service-area/jeffersonville-in",
  "clarksville": "/service-area/clarksville-in",
  "charlestown": "/service-area/charlestown-in",
  // Ohio service area redirects (no longer served)
  "cincinnati-oh": "/service-area",
  "lebanon-oh": "/service-area",
  "mason-oh": "/service-area",
  "hamilton-oh": "/service-area",
  "fairfield-oh": "/service-area",
  "wilmington-oh": "/service-area",
  "west-chester-oh": "/service-area",
  "middletown-oh": "/service-area",
};

export const Route = createFileRoute("/service-area/$slug")({
  beforeLoad: ({ params }) => {
    const target = LEGACY_SLUGS[params.slug];
    if (target) legacyRedirect(target);
    if (!isLocationSlug(params.slug)) throw notFound();
  },
  component: LocationPage,
  notFoundComponent: () => <NotFound hubPath="/service-area" hubLabel="Service Areas" />,
  head: ({ params }) => locationHead(params.slug),
});
